import { getCONSTANTName } from './CONSTANT';
import { internNamespace } from './internNamespace';
import { release } from '@awayfl/swf-loader';
import { assert } from '@awayjs/graphics';
import { internPrefixedNamespace } from './internPrefixedNamespace';
import { axCoerceString } from '../../run/axCoerceString';
import { isNumeric } from '@awayfl/swf-loader';
var Multiname = /** @class */ (function () {
    function Multiname(abc, index, kind, namespaces, name, parameterType, mutable) {
        if (parameterType === void 0) { parameterType = null; }
        if (mutable === void 0) { mutable = false; }
        this.abc = abc;
        this.index = index;
        this.kind = kind;
        this.namespaces = namespaces;
        this.name = name;
        this.parameterType = parameterType;
        this.mutable = mutable;
        this.id = Multiname._nextID++;
        this._mangledName = null;
        this.script = null;
        this.numeric = false;
        this.numericValue = 0;
        this.resolved = {};
        this.scope = null;
        this.value = null;
        this._key = null;
        // ...
    }
    Multiname.prototype.set = function (name, namespace) {
        // try to cast name to numeric, required for objects with numeric key's
        // {0: 1}
        var isIndexator = (typeof name === 'number'
            || (typeof name === 'string' // name maybe as object for Map
                && !name.includes('.') // check case when name is `1.0`
                && Number.isInteger(+name) // check that real integer, same as isFinite
            ));
        if (typeof name === 'object') {
            //debugger;
        }
        this.namespaces = namespace ? [namespace] : [];
        this.name = name;
        this.numeric = false;
        if (isIndexator) {
            this.numericValue = +name;
            this.numeric = true;
        }
    };
    /**
     * Drop field for RT name
     * @see https://github.com/awayfl/avm2/issues/4
     */
    Multiname.prototype.drop = function () {
        if (!this.mutable || !this.isRuntimeName) {
            // throw "DROP allowed only foe runtime name";
            return;
        }
        this.numeric = false;
        this.name = undefined;
        this.namespaces = [];
        this.scope = null;
        this.numericValue = NaN;
        this.resolved = {};
    };
    Multiname.prototype.key = function () {
        if (this._key)
            return this._key;
        var r = this.toString();
        if (!this.mutable)
            this._key = r;
        return r;
    };
    Multiname.FromFQNString = function (fqn, nsType) {
        var lastDot = fqn.lastIndexOf('.');
        var uri = lastDot === -1 ? '' : fqn.substr(0, lastDot);
        var name = lastDot === -1 ? fqn : fqn.substr(lastDot + 1);
        var ns = internNamespace(nsType, uri);
        return new Multiname(null, 0, 15 /* RTQName */, [ns], name);
    };
    Multiname.prototype._nameToString = function () {
        if (this.isAnyName()) {
            return '*';
        }
        return this.isRuntimeName() ? '[' + this.name + ']' : this.name;
    };
    Multiname.prototype.isRuntime = function () {
        switch (this.kind) {
            case 7 /* QName */:
            case 13 /* QNameA */:
            case 9 /* Multiname */:
            case 14 /* MultinameA */:
                return false;
        }
        return true;
    };
    Multiname.prototype.isRuntimeName = function () {
        switch (this.kind) {
            case 17 /* RTQNameL */:
            case 18 /* RTQNameLA */:
            case 27 /* MultinameL */:
            case 28 /* MultinameLA */:
                return true;
        }
        return false;
    };
    Multiname.prototype.isRuntimeNamespace = function () {
        switch (this.kind) {
            case 15 /* RTQName */:
            case 16 /* RTQNameA */:
            case 17 /* RTQNameL */:
            case 18 /* RTQNameLA */:
                return true;
        }
        return false;
    };
    Multiname.prototype.isAnyName = function () {
        return this.name === null;
    };
    Multiname.prototype.isAnyNamespace = function () {
        if (this.isRuntimeNamespace() || this.namespaces.length > 1) {
            return false;
        }
        return this.namespaces.length === 0 || this.namespaces[0].uri === '';
        // x.* has the same meaning as x.*::*, so look for the former case and give
        // it the same meaning of the latter.
        // return !this.isRuntimeNamespace() &&
        //  (this.namespaces.length === 0 || (this.isAnyName() && this.namespaces.length !== 1));
    };
    Multiname.prototype.isQName = function () {
        var kind = this.kind;
        var result = kind === 29 /* TypeName */ ||
            kind === 7 /* QName */ || kind === 13 /* QNameA */ ||
            kind >= 15 /* RTQName */ && kind <= 18 /* RTQNameLA */;
        release || assert(!(result && this.namespaces.length !== 1));
        return result;
    };
    Object.defineProperty(Multiname.prototype, "namespace", {
        get: function () {
            release || assert(this.isQName());
            return this.namespaces[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Multiname.prototype, "uri", {
        get: function () {
            release || assert(this.isQName());
            return this.namespaces[0].uri;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Multiname.prototype, "prefix", {
        get: function () {
            release || assert(this.isQName());
            return this.namespaces[0].prefix;
        },
        set: function (prefix) {
            release || assert(this.isQName());
            var ns = this.namespaces[0];
            if (ns.prefix === prefix) {
                return;
            }
            this.namespaces[0] = internPrefixedNamespace(ns.type, ns.uri, prefix);
        },
        enumerable: true,
        configurable: true
    });
    Multiname.prototype.equalsQName = function (mn) {
        release || assert(this.isQName());
        return this.name === mn.name && this.namespaces[0].uri === mn.namespaces[0].uri;
    };
    Multiname.prototype.matches = function (mn) {
        release || assert(this.isQName());
        var anyName = mn.isAnyName();
        if (anyName && !mn.isQName()) {
            return true;
        }
        if (!anyName && this.name !== mn.name) {
            return false;
        }
        var uri = this.namespaces[0].uri;
        // @todo: not sure about this.
        // seems like its needed to match for xml nodes that have uri==""
        if (uri == '' || uri == 'default')
            return true;
        for (var i = mn.namespaces.length; i--;) {
            // @todo: not sure about this. needed for xml
            if (mn.namespaces[i].uri == '' || mn.namespaces[i].uri === uri) {
                return true;
            }
        }
        return false;
    };
    Multiname.prototype.isAttribute = function () {
        switch (this.kind) {
            case 13 /* QNameA */:
            case 16 /* RTQNameA */:
            case 18 /* RTQNameLA */:
            case 14 /* MultinameA */:
            case 27 /* MultinameL */:
            case 28 /* MultinameLA */:
                return true;
        }
        return false;
    };
    Multiname.prototype.getMangledName = function () {
        release || assert(this.isQName());
        return this._mangledName || this._mangleName();
    };
    Multiname.prototype._mangleName = function () {
        release || assert(!this._mangledName);
        var mangledName = '$Bg' + axCoerceString(this.name);
        if (!this.isRuntime()) {
            this._mangledName = mangledName;
        }
        return mangledName;
    };
    Multiname.prototype.getPublicMangledName = function () {
        if (isNumeric(this.name)) {
            return this.name;
        }
        return '$Bg' + axCoerceString(this.name);
    };
    Multiname.isPublicQualifiedName = function (value) {
        return value.indexOf('$Bg') === 0;
    };
    Multiname.getPublicMangledName = function (name) {
        if (isNumeric(name)) {
            return name;
        }
        return '$Bg' + name;
    };
    Multiname.prototype.toFQNString = function (useColons) {
        release || assert(this.isQName());
        var prefix = this.namespaces[0].uri;
        if (prefix.length) {
            prefix += (useColons ? '::' : '.');
        }
        return prefix + this.name;
    };
    Multiname.prototype.toString = function () {
        var str = getCONSTANTName(this.kind) + ' ';
        str += this.isAttribute() ? '@' : '';
        if (this.isRuntimeNamespace()) {
            var namespaces = this.namespaces ? this.namespaces.map(function (x) { return String(x); }).join(', ') : null;
            str += '[' + namespaces + ']::' + this._nameToString();
        }
        else if (this.isQName()) {
            str += this.namespaces[0] + '::';
            str += this._nameToString();
        }
        else if (this.namespaces) {
            str += '{' + this.namespaces.map(function (x) { return String(x); }).join(', ') + '}';
            str += '::' + this._nameToString();
        }
        else {
            str += '{' + this.namespaces + '}';
            str += '::' + this._nameToString();
        }
        if (this.parameterType) {
            str += '<' + this.parameterType + '>';
        }
        return str;
    };
    Multiname.prototype.toFlashlogString = function () {
        var namespaceUri = this.uri;
        return namespaceUri ? namespaceUri + '::' + this.name : this.name;
    };
    /**
     * Removes the public prefix, or returns undefined if the prefix doesn't exist.
     */
    Multiname.stripPublicMangledName = function (name) {
        if (name.indexOf('$Bg') === 0) {
            return name.substring(3);
        }
        return undefined;
    };
    Multiname.FromSimpleName = function (simpleName) {
        var _a;
        var realName = '';
        //	hack when simple-name is a XMLList returned from "attribute" getter
        //	when working with xml
        if (typeof simpleName !== 'string' && ((_a = simpleName._children) === null || _a === void 0 ? void 0 : _a.length) === 1) {
            simpleName = simpleName._children[0]._value || '';
        }
        else {
            realName = simpleName;
        }
        //case for `com.package.name::className`
        var nameIndex = realName.lastIndexOf('::');
        if (nameIndex > 0) {
            // trim extra :
            realName = realName.replace('::', ':');
        }
        else {
            //case for `com.package.name.className`
            nameIndex = realName.lastIndexOf('.');
        }
        if (nameIndex <= 0) {
            //case for `com.package.name className`
            nameIndex = realName.lastIndexOf(' ');
        }
        var uri = '';
        var name = realName;
        if (nameIndex > 0 && nameIndex < realName.length - 1) {
            name = realName.substring(nameIndex + 1).trim();
            uri = realName.substring(0, nameIndex).trim();
        }
        var ns = internNamespace(0 /* Public */, uri);
        return new Multiname(null, 0, 15 /* RTQName */, [ns], name);
    };
    Multiname._nextID = 1;
    return Multiname;
}());
export { Multiname };
